var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25049 60.0005C9.25049 31.972 31.972 9.25049 60.0005 9.25049C88.0289 9.25049 110.75 31.972 110.75 60.0005C110.75 88.0289 88.0289 110.75 60.0005 110.75C31.972 110.75 9.25049 88.0289 9.25049 60.0005ZM44.0426 62.6859C47.3404 58.156 51.0076 53.9362 55.0003 50.0711L55.0003 80C55.0003 82.7614 57.2389 85 60.0003 85C62.7618 85 65.0003 82.7614 65.0003 80L65.0003 50.0711C68.993 53.9363 72.6602 58.156 75.958 62.6859C77.5832 64.9184 80.7106 65.4107 82.9431 63.7854C85.1756 62.1602 85.6678 59.0329 84.0426 56.8004C78.6053 49.3315 72.2505 42.6193 65.1371 36.8312C63.6516 35.6224 61.8335 35 60.0003 35C58.1672 35 56.3491 35.6224 54.8635 36.8312C47.7501 42.6193 41.3953 49.3315 35.958 56.8004C34.3328 59.0329 34.825 62.1602 37.0575 63.7854C39.29 65.4107 42.4174 64.9184 44.0426 62.6859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.eb195dbdee2c1d9a2e0cf04b87b78a01.svg";
export { ForwardRef as ReactComponent };